export const FETCH_BENEFITS = "FETCH_BENEFITS";
export const FETCH_BENEFITS_SUCCESS = "FETCH_BENEFITS_SUCCESS";
export const FETCH_BENEFITS_FAILURE = "FETCH_BENEFITS_FAILURE";

export const CREATE_BENEFIT = "CREATE_BENEFIT";
export const CREATE_BENEFIT_SUCCESS = "CREATE_BENEFIT_SUCCESS";
export const CREATE_BENEFIT_FAILURE = "CREATE_BENEFIT_FAILURE";

export const UPDATE_BENEFIT = "UPDATE_BENEFIT";
export const UPDATE_BENEFIT_SUCCESS = "UPDATE_BENEFIT_SUCCESS";
export const UPDATE_BENEFIT_FAILURE = "UPDATE_BENEFIT_FAILURE";

export const DELETE_BENEFIT = "DELETE_BENEFIT";
export const DELETE_BENEFIT_SUCCESS = "DELETE_BENEFIT_SUCCESS";
export const DELETE_BENEFIT_FAILURE = "DELETE_BENEFIT_FAILURE";

export const DELETE_BENEFITS = "DELETE_BENEFITS";
export const DELETE_BENEFITS_SUCCESS = "DELETE_BENEFITS_SUCCESS";
export const DELETE_BENEFITS_FAILURE = "DELETE_BENEFITS_FAILURE";

export const GET_BENEFIT = "GET_BENEFIT";
export const GET_BENEFIT_SUCCESS = "GET_BENEFIT_SUCCESS";
export const GET_BENEFIT_FAILURE = "GET_BENEFIT_FAILURE";

export const GET_BENEFIT_VALUES = "GET_BENEFIT_VALUES";
export const GET_BENEFIT_VALUES_SUCCESS = "GET_BENEFIT_VALUES_SUCCESS";
export const GET_BENEFIT_VALUES_FAILURE = "GET_BENEFIT_VALUES_FAILURE";

export const RESET_BENEFIT = "RESET_BENEFIT";
